import { LoanApplicationPreferences } from "@common/company/configurations/loan-application-preferences";
import { useQuery } from "@tanstack/react-query";
import { useTenant } from "modules/tenant/providers/tenant-provider";
import { api } from "utils/api";

export const useLoanApplicationPreferences = () => {
  const { user } = useTenant();

  const fetch = async (): Promise<LoanApplicationPreferences> => {
    const response = await api.get("/supabase/loan-application-preferences");

    return (
      response.data ?? {
        enable_signatures: false,
      }
    );
  };

  return useQuery({
    queryKey: ["loanApplicationPreferences", user.id],
    queryFn: async () => await fetch(),
    staleTime: 1000 * 60 * 60 * 6, // 6 hours
  });
};
